export const ENGRAVING_FONTS = [
  { id: "Classic Serif", family: "'Cormorant Garamond', Georgia, serif", weight: 500, transform: "none", spacing: 0.02, scale: 1.08 },
  { id: "Modern Sans", family: "'Manrope', 'Helvetica Neue', sans-serif", weight: 600, transform: "uppercase", spacing: 0.22, scale: 0.78 },
  { id: "Script", family: "'Great Vibes', cursive", weight: 400, transform: "none", spacing: 0.01, scale: 1.25 },
  { id: "Monogram", family: "'Cinzel', serif", weight: 700, transform: "uppercase", spacing: 0.18, scale: 0.8 },
];

const TONES = {
  steel: { fill: "#E8EBED", shadow: "0 0 1px rgba(255,255,255,.7), 0 0 10px rgba(255,255,255,.22), 0 1px 2px rgba(0,0,0,.5)", blend: "normal", patch: "rgba(18,18,20,.55)" },
  etch: { fill: "#DDE1E4", shadow: "0 1px 1px rgba(0,0,0,.7), 0 0 8px rgba(255,255,255,.2)", blend: "normal", patch: "rgba(40,42,45,.6)" },
  burn: { fill: "#1E0F06", shadow: "0 0 1px rgba(0,0,0,.8), 0 1px 0 rgba(255,220,180,.15)", blend: "normal", patch: "rgba(128,84,48,.82)" },
  dark: { fill: "#2E1F0C", shadow: "0 0 1px rgba(0,0,0,.7), 0 1px 0 rgba(255,235,190,.2)", blend: "normal", patch: "rgba(190,150,80,.7)" },
  gold: { fill: "#E2BE78", shadow: "0 0 1px rgba(255,230,170,.7), 0 0 8px rgba(217,180,110,.3)", blend: "normal", patch: "rgba(8,8,10,.6)" },
};

export const toneStyle = (tone) => TONES[tone] || TONES.steel;

const ZONES = {
  "steel-tumbler": { x: 50, y: 47, w: 26, r: 0, tone: "steel" },
  "yeti-rambler": { x: 47, y: 52, w: 28, r: 0, tone: "etch" },
  "stanley-quencher": { x: 47, y: 53, w: 24, r: 0, tone: "steel" },
  "engrave-your-own-tumbler": { x: 82, y: 50, w: 15, r: 0, tone: "steel" },
  "topographic-tumbler": { x: 50, y: 50, w: 26, r: 0, tone: "steel" },
  "walnut-board": { x: 50, y: 50, w: 46, r: 0, tone: "burn" },
  "recipe-board": { x: 50, y: 50, w: 46, r: 0, tone: "burn" },
  "wedding-sign": { x: 62, y: 52, w: 40, r: -12, tone: "burn" },
  "slate-coasters": { x: 50, y: 46, w: 36, r: -8, tone: "etch" },
  "brass-pet-tag": { x: 50, y: 63, w: 24, r: 0, tone: "dark" },
  "leather-key-fob": { x: 50, y: 50, w: 28, r: -30, tone: "burn" },
  "leather-journal": { x: 62, y: 68, w: 36, r: -6, tone: "burn" },
  "metal-business-cards": { x: 50, y: 60, w: 32, r: -22, tone: "gold" },
  "stainless-flask": { x: 50, y: 55, w: 30, r: 0, tone: "steel" },
};

const byMaterial = (material = "") => {
  const m = material.toLowerCase();
  if (/walnut|wood|leather/.test(m)) return "burn";
  if (/brass/.test(m)) return "dark";
  if (/slate|white/.test(m)) return "etch";
  if (/aluminum|aluminium/.test(m)) return "gold";
  return "steel";
};

export const zoneFor = (product) => ZONES[product.slug] || { x: 50, y: 50, w: 32, r: 0, tone: byMaterial(product.material) };
